import { render } from "./DSidebarSearchbox.vue?vue&type=template&id=fc0795da&scoped=true"
import script from "./DSidebarSearchbox.vue?vue&type=script&lang=js"
export * from "./DSidebarSearchbox.vue?vue&type=script&lang=js"

import "./DSidebarSearchbox.vue?vue&type=style&index=0&id=fc0795da&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc0795da"]])

export default __exports__